var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 16h3c0 6.904 5.596 12.5 12.5 12.5S28.5 22.904 28.5 16 22.904 3.5 16 3.5v-3C24.56.5 31.5 7.44 31.5 16c0 8.56-6.94 15.5-15.5 15.5C7.44 31.5.5 24.56.5 16z",
    fill: "currentColor"
  })));
}

var MemoSvgSpinner = /*#__PURE__*/React.memo(SvgSpinner);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHBhdGggZD0iTS41IDE2aDNjMCA2LjkwNCA1LjU5NiAxMi41IDEyLjUgMTIuNVMyOC41IDIyLjkwNCAyOC41IDE2IDIyLjkwNCAzLjUgMTYgMy41di0zQzI0LjU2LjUgMzEuNSA3LjQ0IDMxLjUgMTZjMCA4LjU2LTYuOTQgMTUuNS0xNS41IDE1LjVDNy40NCAzMS41LjUgMjQuNTYuNSAxNnoiIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4K";
export { MemoSvgSpinner as ReactComponent };